import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import config from 'config'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'
import styles from './styles.module.scss'
import MixrCard from 'srcReact/components/common2/MixrCard'
import NotFound from 'srcReact/components/common2/NotFound'
import { groupHomeActions } from 'srcReact/GroupHomePage'
import Spinner from 'srcReact/components/common2/Spinner'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { checkNested } from 'srcReact/helpers/validator'
import { rsvpActions } from 'srcReact/components/common2/RSVP/actions'

const UpcomingMixrs = ({ groupId, isMobile, moderationInfo }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [scope] = useState('future_mixrs')
  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })
  const {
    rsvp: { loading: rsvpLoading, success: rsvpSuccess, error: rsvpError, data: rsvpData },
    groupHome: { future_mixrs, group, futureMixrsLoading }
  } = useSelector((state) => state)
  useEffect(() => {
    if (groupId) {
      dispatch(groupHomeActions.getGroupHomeMixrFutureList(groupId, scope))
    }
  }, [])

  useEffect(() => {
    if (!rsvpLoading && rsvpSuccess && rsvpData) {
      dispatch(groupHomeActions.updateRSVPData(rsvpData.mixr_id, rsvpData, pagination.nextOffset))
      dispatch(rsvpActions.clearData())
    }
  }, [rsvpLoading, rsvpSuccess])
  useEffect(() => {
    if (groupId && pagination.isPagination) {
      dispatch(groupHomeActions.getGroupHomeMixrFutureListPagination(groupId, scope, pagination.nextOffset))
    }
  }, [pagination])

  const infiniteScrollRef = useInfinitScroll(
    future_mixrs.loading,
    future_mixrs.stats.remaining,
    future_mixrs.stats.next_offset,
    setPagination,
    [future_mixrs.loading]
  )

  const isMemberOfGroup = group.logged_user.group_role !== 'none'

  if (future_mixrs.mixrs && future_mixrs.mixrs.length === 0 && future_mixrs.loading && futureMixrsLoading) {
    return <Spinner />
  }

  return (
    <React.Fragment>
      {future_mixrs.mixrs && future_mixrs.mixrs.length >= 1 ? (
        <React.Fragment>
          <div className={styles.upcomingWrapper}>
            {future_mixrs.mixrs.map((m, i) => {
              let parentMixrId = null

              if (m.is_recurrent_mixr === 1) {
                const suspendMixrObjs = moderationInfo?.mixrs?.suspended_mixr_urls
                if (suspendMixrObjs) {
                  const entries = Object.entries(suspendMixrObjs)
                  const suspendedMixr = entries.find((x) => x[0] == m.id)
                  parentMixrId = suspendedMixr && suspendedMixr[1]
                }
              }
              return (
                <MixrCard
                  key={i}
                  infiniteScrollRef={infiniteScrollRef}
                  mixrId={m.id}
                  groupId={groupId}
                  picture={m?.picture?.url}
                  startDate={m.utc_start_at}
                  endDate={m.utc_end_at}
                  utcOffset={m.location.timezone.UTCOffset || '+00:00'}
                  timezone={m.location.timezone.timeZoneAbbreviation}
                  participants={m.participants_number}
                  url={m.url}
                  title={m.name}
                  name={group.name}
                  description={m.description}
                  color={m.color ? m.color : appConstantSettings.DEFAULT_COLOR.name}
                  isRecurrence={m.is_recurrent_mixr === 1 ? true : false}
                  parentMixrId={parentMixrId}
                  attendance={m.attending_type}
                  userAttendance={m.logged_user.mixr_attending}
                  layout='horizontal'
                  organizer={{ name: group.organizer.display_name }}
                  menuPortalTarget={true}
                  withGroupDetails={true}
                  groupAttendingStatus={group?.logged_user?.group_attending}
                  isVisibility={group.privacy_setting !== 'public'}
                  mixrOrganizer={`${m.organizer_firstname} ${m.organizer_lastname}`}
                  mixrRole={m.logged_user.mixr_role}
                  groupRole={group.logged_user.group_role}
                  isSuspended={
                    checkNested(moderationInfo, 'mixrs', 'suspended_mixrs') &&
                    moderationInfo.mixrs.suspended_mixrs.some((x) => x === m.id)
                  }
                  withoutGroupApproval={m.logged_user.without_group_approval}
                  isInvited={m.logged_user.is_invited === 1}
                />
              )
            })}
          </div>
          {future_mixrs.loading && <Spinner />}
        </React.Fragment>
      ) : (
        future_mixrs.loaded && (
          <NotFound
            title={t('groupHome.mixrs.notFound.title')}
            button={t('global.planMixr')}
            handleClick={() => (window.location = `/0/${group.id}/create-mixr`)}
          />
        )
      )}
    </React.Fragment>
  )
}

export default UpcomingMixrs
